import React from 'react'
import { KruzeKontrolApiHelper } from 'helpers/kruzeKontrolApiHelper'

export const ApiHelperContext = React.createContext<KruzeKontrolApiHelper>(null)
